import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SYSTEM_ERROR_CODE } from 'app/models/constants-status';
import { RequestStatus } from 'app/models/request-status.model';
import { UserCourseRegistration } from 'app/models/user-course-registration';
import { UserCourseRegistrationParameter } from 'app/models/user-course-registration-parameter.model';
import { User } from 'app/models/user.model';
import { environment } from 'environments/environment';
import { Observable, lastValueFrom } from 'rxjs';
import { ErrorMessageService } from './error-message.service';

@Injectable({
  providedIn: 'root',
})
export class UserCourseRegistrationService {
  private http = inject(HttpClient);
  private errorMessageService = inject(ErrorMessageService);

  public errorMessage = '';
  public async getUserCourseRegistrations(user: User): Promise<UserCourseRegistration[] | number> {
    try {
      if (!user) {
        return;
      }
      const options = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${environment.authenticationToken}`,
          'User-Token': user.token,
        }),
      };

      const userCourseRegistrationObservable = this.http.get<RequestStatus>(
        environment.apiUrlUserCourseRegistration.replace('{{user_id}}', user.id.toString()),
        options,
      );
      const userCourseRegistrations: UserCourseRegistration[] = [];

      const requestStatus = await lastValueFrom(userCourseRegistrationObservable);

      requestStatus.data.forEach((userCourseRegistration) => {
        userCourseRegistrations.unshift(userCourseRegistration);
      });

      return userCourseRegistrations;
    } catch (error) {
      if (error.status === 401) {
        console.log('User-Token abgelaufen');
        return 401;
      }
      this.errorMessage = error.message;
      return SYSTEM_ERROR_CODE;
    }
  }

  public registerUserForCourse(
    userCourseRegistration: UserCourseRegistrationParameter,
    token: string,
    userId: number,
  ): Observable<RequestStatus | number> {
    try {
      const options = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${environment.authenticationToken}`,
          'User-Token': token,
        }),
      };

      const body = JSON.stringify(userCourseRegistration);

      const observable = this.http.post<RequestStatus>(
        environment.apiUrlUserCourseRegistration.replace('{{user_id}}', userId.toString()),
        body,
        options,
      );

      return observable;
    } catch (error) {
      if (error.status === 401) {
        console.log('User-Token abgelaufen');

        return new Observable((observer) => {
          observer.next(401);
          observer.complete();
        });
      }
      this.errorMessage = error.message;
      return new Observable((observer) => {
        observer.next(SYSTEM_ERROR_CODE);
        observer.complete();
      });
    }
  }
}
